import { useMemo } from 'react';
import uniqueId from 'lodash/uniqueId';

const useId = (prefix?: string) => useMemo(() => uniqueId(prefix), [prefix]);

export default useId;
